/**
 * @module components/XAxisLabelDirection
 * @description X轴标签方向配置 — 对齐 ChartsDrop x_label 表单项
 *
 * 控件类型：下拉选择（自动 / 水平）
 * 支持图表：柱状图 / 堆叠图 / 百分比堆叠图 / 折线图 / 组合图 / 事件折线图
 * 挂载位置：XAxisSetting 卡片内，排序方式之后
 */
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'umi';
import { Select } from 'tea-component';
import { useSettingState } from '../../context';
import '../common/SortByPanel/index.scss';

const XAxisLabelDirection: React.FC = () => {
  const { formatMessage } = useIntl();
  const { value: storedValue, setValue } = useSettingState('x_label');

  const options = useMemo(
    () => [
      { value: 'auto', text: formatMessage({ id: 'dbl_chart_auto' }) },
      { value: 'horizontal', text: formatMessage({ id: 'dbl_chart_horizontal' }) },
    ],
    [formatMessage],
  );

  const selectValue = storedValue === 'horizontal' ? 'horizontal' : 'auto';

  const handleChange = useCallback(
    (next: string) => {
      setValue(next);
    },
    [setValue],
  );

  return (
    <div className="dbl-chart-setting-row">
      <span className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_x_label' })}
      </span>
      <Select
        className="dbl-sort-by-panel__select"
        appearance="button"
        listWidth={232}
        matchButtonWidth
        value={selectValue}
        options={options}
        onChange={handleChange}
      />
    </div>
  );
};

export default React.memo(XAxisLabelDirection);
